const decimalAdjust = ( type, value, exp ) => {
	if ( typeof exp === 'undefined' || exp === 0 )
	{
		return Math[type]( value );
	}

	let v = value;
	let e = exp;

	v = Number( v );
	e = e ? Number( e ) * -1 : 1;

	if ( isNaN( v ) || !( typeof e === 'number' && e % 1 === 0 ) )
	{
		return NaN;
	}

	v = v.toString().split( 'e' );
	v = Math[type]( Number( `${v[0]}e${v[1] ? ( Number( v[1] ) - exp ) : -exp}` ) );
	v = v.toString().split( 'e' );
	
	return Number( `${v[0]}e${v[1] ? Number( v[1] ) + exp : exp}` );
};

export const decimalCeil = ( value, exp ) => {
	return decimalAdjust( 'ceil', value, exp );
};

export const decimalFloor = ( value, exp ) => {
	return decimalAdjust( 'floor', value, exp );
};

export const decimalRound = ( value, exp ) => {
	return decimalAdjust( 'round', value, exp );
};
